// ═══ TYPE CONFIG ═══════════════════════════════════════════
// The `TC` (TYPE_CONFIG) table describing every question type, plus the flag
// helpers (HC/HG/HS/HCN/HF) and initMeta(). Ported verbatim from
// legacy/EMR Forms.html. Typed loosely (Record<string,any>) so string-key
// indexing (TC[q.type]) type-checks without changing behavior.

export const TC: Record<string, any> = {
  SHORT_TEXT:  {l:'Short Text',  i:'Aa', bg:'rgba(79,140,255,.15)', c:'#4f8cff', cat:'Text'},
  LONG_TEXT:   {l:'Long Text',   i:'¶',  bg:'rgba(123,92,255,.15)',c:'#7b5cff', cat:'Text'},
  EMAIL:       {l:'Email',       i:'@',  bg:'rgba(34,197,94,.15)', c:'#22c55e', cat:'Text'},
  PHONE:       {l:'Phone Number',i:'☎', bg:'rgba(13,148,136,.15)',c:'#0d9488', cat:'Text'},
  DATETIME:    {l:'Date & Time', i:'📆', bg:'rgba(56,189,248,.15)',c:'#38bdf8', cat:'Date & Time'},
  SINGLE_CHOICE:{l:'Select One', i:'◉',  bg:'rgba(239,68,68,.15)', c:'#ef4444', cat:'Choice',   ch:1},
  MULTI_SELECT:{l:'Select Many', i:'☑',  bg:'rgba(20,184,166,.15)',c:'#14b8a6', cat:'Choice',   ch:1},
  CHECKBOX_OTHER:{l:'Checkbox + Other',i:'☒',bg:'rgba(20,184,166,.15)',c:'#0ea5e9',cat:'Choice', ch:1},
  DROPDOWN:    {l:'Dropdown',    i:'▼',  bg:'rgba(249,115,22,.15)',c:'#f97316', cat:'Choice',   ch:1},
  RANKING:     {l:'Ranking',     i:'⇅',  bg:'rgba(168,85,247,.15)',c:'#a855f7', cat:'Choice',   ch:1},
  RATING:      {l:'Rating',      i:'★',  bg:'rgba(236,72,153,.15)',c:'#ec4899', cat:'Scale'},
  LINEAR_SCALE:{l:'Linear Scale',i:'↔',  bg:'rgba(99,102,241,.15)',c:'#6366f1', cat:'Scale',    sc:1},
  RANGE:       {l:'Range',       i:'⟺',  bg:'rgba(99,102,241,.15)',c:'#6366f1', cat:'Scale',    sc:1},
  MULTI_CHOICE_GRID:{l:'Choice Grid',  i:'⊞',bg:'rgba(16,185,129,.15)',c:'#10b981',cat:'Grid',gr:1},
  TICK_BOX_GRID:    {l:'Checkbox Grid',i:'⊟',bg:'rgba(16,185,129,.15)',c:'#10b981',cat:'Grid',gr:1},
  QUESTION_MATRIX:  {l:'Question Matrix',i:'⊠',bg:'rgba(16,185,129,.15)',c:'#10b981',cat:'Grid',gr:1},
  PHOTO:       {l:'Picture Upload',i:'📷',bg:'rgba(234,179,8,.15)', c:'#f59e0b', cat:'Media'},
  FILE_UPLOAD: {l:'File Upload', i:'📎', bg:'rgba(234,179,8,.15)', c:'#eab308', cat:'Media'},
  NOTE:        {l:'Note',        i:'📝', bg:'rgba(113,113,122,.15)',c:'#a1a1aa',cat:'Special',  cn:1},
  ACKNOWLEDGE: {l:'Acknowledge', i:'✓',  bg:'rgba(34,197,94,.15)', c:'#22c55e', cat:'Special',  cn:1},
};

export const HC = (t: string): boolean => !!(TC[t] && TC[t].ch);
export const HG = (t: string): boolean => !!(TC[t] && TC[t].gr);
export const HS = (t: string): boolean => !!(TC[t] && TC[t].sc);
export const HCN = (t: string): boolean => !!(TC[t] && TC[t].cn);
export const HF = (t: string): boolean => !!(TC[t] && TC[t].fm);

export function initMeta(t: string): any {
  const br = { byValue: {}, defaultNext: '' };
  if (t === 'CHECKBOX_OTHER') return { choices: [], branch: br, mode: 'multi', otherLabel: 'Other' };
  if (t === 'RANKING') return { choices: [], branch: br, rankSelectCount: 0 };
  if (HC(t)) return { choices: [], branch: br };
  if (HG(t)) return { rows: [], cols: [], branch: br };
  if (HS(t)) return { min: 1, max: 5, step: 1, minLabel: '', maxLabel: '', branch: br };
  if (t === 'RATING') return { max: 10, branch: br };
  if (HCN(t)) return { content: '', branch: br };
  if (HF(t)) return { formula: '', branch: br };
  if (t === 'HIDDEN') return { defaultValue: '', branch: br };
  if (['PHOTO', 'AUDIO', 'VIDEO', 'FILE_UPLOAD'].includes(t)) return { folder: '', maxFileSizeMB: 0, branch: br };
  if (t === 'LOCATION') return { branch: br };
  if (t === 'PHONE') return { defaultCountry: 'IN', branch: br };
  return { placeholder: '', regex: '', branch: br };
}
